angular.module('gym.sequences').factory('Sequences', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('sequences').all('sequences');
}]);
